'use strict';

/* globals config, document, $, socket, app, ajaxify */

require([
	config.relative_path + '/plugins/nodebb-plugin-ideas-board/static/vendor/vue.js',
	config.relative_path + '/plugins/nodebb-plugin-ideas-board/static/vendor/html2canvas.js',
	'reimg',
	'benchpress',
	'slugify',
	'bootbox',
], function (Vue, html2canvas, ReImg, Benchpress, slugify, bootbox) {
	var internals = {};

	Vue.component('ideas-board', {
		props: ['isBoardOwner'],
		data: function () {
			return {
				boardId: parseInt($('#board').attr('data-board'), 10),
			};
		},
		methods: {
			saveBoard: function () {
				internals.export();
			},
			removeBoard: function () {
				internals.remove(this.boardId);
			},
			renameBoard: function () {
				internals.rename(this.boardId);
			},
		},
		template: '<div class="ideas-board">' +
			'<board-menu v-bind:save-board="saveBoard" v-bind:remove-board="removeBoard" v-bind:rename-board="renameBoard" :is-board-owner="isBoardOwner"></board-menu>' +
			'<board-canvas></board-canvas>' +
			'</div>',
	});

	internals.export = function () {
		var el = $('.ib-board');

		el.removeClass('ib-board-bg');

		html2canvas(document.querySelector('.ib-board'), {
			windowWidth: el.width(),
			windowHeight: el.height(),
		}).then(function (canvas) {
			el.addClass('ib-board-bg');

			var boardImg = ReImg.fromCanvas(canvas);

			Benchpress.parse('board/board-export-modal', { }, function (html) {
				bootbox.dialog({
					title: '[[ideas-board:exported-board]]',
					message: html,
					size: 'large',
					buttons: {
						cancel: {
							label: '[[modules:bootbox.cancel]]',
							className: 'btn-link',
						},
						save: {
							label: '[[global:save]]',
							className: 'btn-primary',
							callback: function () {
								boardImg.downloadPng();
							},
						},
					},
				});

				$('#exportedBoardImgPreview').attr('src', boardImg.toBase64());
			});
		});
	};

	internals.remove = function (boardId) {
		bootbox.confirm('[[ideas-board:board-remove-question]]', function (confirm) {
			if (!confirm) {
				return;
			}

			socket.emit('plugins.ideasBoard.removeBoard', { boardId: boardId }, function (err) {
				if (err) {
					return app.alertError(err.message);
				}

				app.alert({
					alert_id: 'board_removed',
					message: '[[ideas-board:board-removed]]',
					type: 'success',
					timeout: 2000,
				});

				ajaxify.go('groups/' + ajaxify.data.group.slug + '/boards');
			});
		});
	};

	internals.rename = function (boardId) {
		Benchpress.parse('board/rename-board', { name: ajaxify.data.board.name }, function (html) {
			var modal = bootbox.dialog({
				title: '[[ideas-board:board-rename]]',
				message: html,
				buttons: {
					save: {
						label: '[[global:save]]',
						className: 'btn-primary',
						callback: submit,
					},
				},
			});

			function submit() {
				var formData = modal.find('form').serializeObject();

				if (!formData.name.length) {
					return app.alertError('[[ideas-board:board-name-required]]');
				}

				socket.emit('plugins.ideasBoard.renameBoard', { boardId: boardId, name: formData.name }, function (err) {
					if (err) {
						return app.alertError(err.message);
					}

					app.alert({
						alert_id: 'board_renamed',
						message: '[[ideas-board:board-renamed]]',
						type: 'success',
						timeout: 2000,
					});

					ajaxify.go('groups/' + ajaxify.data.group.slug + '/board/' + boardId + '/' + slugify(formData.name));
				});

				modal.modal('hide');

				return false;
			}

			modal.find('form').on('submit', submit);
		});
	};
});
